import { useMediaQuery } from '@mui/material'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from 'ui/atoms/Icon/Icon'
import Tooltip from 'ui/components/Tooltip/Tooltip'

import styles from './ToggleMenuTab.module.less'

type ToggleMenuTabProps = {
  number: number
  menuWidth: number
  icon?: string
  tooltipLabel?: string
  onToggle: (isOpen: boolean) => void
}

export default function ToggleMenuTab({
  number,
  menuWidth,
  icon,
  tooltipLabel,
  onToggle,
}: ToggleMenuTabProps): ReactElement {
  const { t } = useTranslation()
  const isScreenSmall = useMediaQuery('(max-width:1024px)')
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = (): void => {
    const newIsOpen = !isOpen
    setIsOpen(newIsOpen)
    onToggle(newIsOpen)
  }

  return (
    <div
      className={styles.ToggleMenuTab}
      style={{ right: isOpen ? (isScreenSmall ? '200px' : `${menuWidth}%`) : '10px' }}
      onClick={handleToggle}
    >
      <div className={styles.ToggleMenuTab_CenteredContent}>
        <Icon
          icon={isOpen ? 'fal fa-chevron-right' : 'fal fa-chevron-left'}
          size="medium"
          tooltip={{
            title: isOpen ? t('Close') : t('Open'),
            placement: 'left',
          }}
        />
      </div>
      <div className={styles.ToggleMenuTab_Content}>
        <div>
          <Icon icon={icon} size="medium" />
        </div>
        <Tooltip title={tooltipLabel ? t(`${tooltipLabel}`) : ''} placement="left">
          <div className={styles.ToggleMenuTab_YellowCircle}>{number}</div>
        </Tooltip>
      </div>
    </div>
  )
}
